'use strict';

exports.__esModule = true;
exports.set = exports.log = exports.lww = undefined;
exports.reduce = reduce;
exports.ron2js = ron2js;

var _lww = require('./lww');

Object.defineProperty(exports, 'lww', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lww).default;
  }
});

var _log = require('./log');

Object.defineProperty(exports, 'log', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_log).default;
  }
});

var _set = require('./set');

Object.defineProperty(exports, 'set', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_set).default;
  }
});

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

var _lww2 = _interopRequireDefault(_lww);

var _log2 = _interopRequireDefault(_log);

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rdt = {
  lww: _lww2.default,
  log: _log2.default,
  set: _set2.default
};

function empty(batch) {
  var ret = new _ron.Frame();
  for (var _iterator = batch.frames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var first = _ref;

    for (var _iterator2 = first, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var op = _ref2;

      var loc = op.uuid(3);
      if (!op.isHeader()) loc = op.uuid(2);
      ret.push(new _ron2.default(op.uuid(0), op.uuid(1),
      // $FlowFixMe
      batch.frames[batch.length - 1][Symbol.iterator]().op.event, loc, undefined, _ron.FRAME_SEP));
      return ret;
    }
  }
  return ret;
}

// Reduce picks a reducer function, performs all the sanity checks,
// invokes the reducer, returns the result
function reduce(batch) {
  var type = _ronUuid.ZERO;
  for (var _iterator3 = batch.frames, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
    var _ref3;

    if (_isArray3) {
      if (_i3 >= _iterator3.length) break;
      _ref3 = _iterator3[_i3++];
    } else {
      _i3 = _iterator3.next();
      if (_i3.done) break;
      _ref3 = _i3.value;
    }

    var first = _ref3;

    for (var _iterator4 = first, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
      var _ref4;

      if (_isArray4) {
        if (_i4 >= _iterator4.length) break;
        _ref4 = _iterator4[_i4++];
      } else {
        _i4 = _iterator4.next();
        if (_i4.done) break;
        _ref4 = _i4.value;
      }

      var op = _ref4;

      type = op.type;
      break;
    }
    if (!type.eq(_ronUuid.ZERO)) break;
  }

  if (rdt[type.toString()]) {
    return rdt[type.toString()].reduce(batch);
  }
  return empty(batch);
}

function ron2js(rawFrame) {
  for (var _iterator5 = new _ron.Frame(rawFrame), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
    var _ref5;

    if (_isArray5) {
      if (_i5 >= _iterator5.length) break;
      _ref5 = _iterator5[_i5++];
    } else {
      _i5 = _iterator5.next();
      if (_i5.done) break;
      _ref5 = _i5.value;
    }

    var op = _ref5;

    switch (true) {
      case _lww2.default.type.eq(op.type):
        return _lww2.default.ron2js(rawFrame);
      case _set2.default.type.eq(op.type):
        return _set2.default.ron2js(rawFrame);
      case _ronUuid.ZERO.eq(op.type):
        var v = _set2.default.ron2js(rawFrame);
        // $FlowFixMe
        Object.getPrototypeOf(v).type = '';
        return v;
    }
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/rdt/lib/index.js
// module id = 10
// module chunks = 0